var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_1031)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1014_1031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.4742V14.4742H19V20.4742H25V11.4742C25.0001 11.3757 24.9807 11.2781 24.9431 11.1871C24.9055 11.096 24.8503 11.0133 24.7806 10.9436L17.2806 3.4436C17.211 3.37387 17.1283 3.31855 17.0372 3.2808C16.9462 3.24306 16.8486 3.22363 16.75 3.22363C16.6514 3.22363 16.5538 3.24306 16.4628 3.2808C16.3717 3.31855 16.289 3.37387 16.2194 3.4436L8.71938 10.9436C8.64975 11.0133 8.59454 11.096 8.5569 11.1871C8.51926 11.2781 8.49992 11.3757 8.5 11.4742V20.4742H14.5Z",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 34.0513,
    fill: "white",
    transform: "translate(0.75 0.224121)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1014_1031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.75 0.224121)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.f4731742b09f57a70d15f1532ea53344.svg";
export { ForwardRef as ReactComponent };